import {IGameFilterDefinition} from '../interfaces/game-filter-definition.interface';
import {GameInfo} from '../../games/game-info';
import {removeSpaces} from "../../../../utils/string-helpers";
import {ApplyGameFilterResult} from "../interfaces/game-filter-evaluator.interface";

export class VendorFilter implements IGameFilterDefinition {
  constructor(public readonly id: string,
              private readonly _vendorName: string) {

  }


  applyFilter(gameInfo: GameInfo): ApplyGameFilterResult {
    if(removeSpaces(gameInfo.vendorName.toLowerCase()) === removeSpaces(this._vendorName.toLowerCase())) {
      return ApplyGameFilterResult.IncludeGame;
    }
    return ApplyGameFilterResult.ExcludeGame;
  }

}
